module.exports = {
	"articleTitle1": "University says it isn't aware of any invitations to white nationalist ...",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Spencer",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/new-restaurant-secondary",
	"articleSnippet1": "Nov 27, 2016 ... Richard Spencer, a prominent white nationalist who coined the term “alt-right,” a \nmovement promoting white supremacist ideals, announced ...",
	"articleSnippet2": "Jan 20, 2016 ... Spencer, a wine and cheese bar/restaurant, has recently taken root in Ann Arbor \nwith a focus on serving a menu that constantly changes with ...",
	"foodRecommendations": [
		{
			"text": "Really great cheese platters and the workers are always really knowledgable about what beer/wine pairs well with your food and personal tastes.",
			"person": "Anon"
		}
	],
	"articleTitle2": "Blessed are the cheesemakers: Spencer adds flavor to Ann Arbor ...",
	"address": "113 E Liberty St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.279728,
		"lng": -83.747898
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/spencer.json
// module id = 976
// module chunks = 0